// Boya Mock Data
// Boya malzemeleri, renk, astar ve kat takibi

export const boyaMalzemeler = [
    {
        id: 'by-001',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-13',
        tedarikci: 'Marshall Boya',
        tedarikciFirmaId: 'f-080',
        kategori: 'ic-cephe',
        urunAdi: 'Marshall Maxima',
        aciklama: 'İç cephe ipek mat boya',
        renk: 'Beyaz',
        renkKodu: '#FFFFFF',
        miktar: 100,
        birim: 'kg',
        birimFiyat: 120,
        toplamFiyat: 12000,
        durum: 'teslim',
        stokMiktar: 30,
        kullanilanMiktar: 70,
        uygulamaYeri: 'A Blok Daireler',
        katSayisi: 2,
        uygulamaMetrekare: 1200,
        insaatId: 'c-001',
        not: 'Daire duvarları',
        createdAt: '2026-01-12T09:00:00Z',
        updatedAt: '2026-01-17T16:00:00Z',
    },
    {
        id: 'by-002',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-13',
        tedarikci: 'Filli Boya',
        tedarikciFirmaId: 'f-081',
        kategori: 'astar',
        urunAdi: 'Filli Momento',
        aciklama: 'Su bazlı astar',
        renk: 'Beyaz',
        renkKodu: '#FFFFFF',
        miktar: 50,
        birim: 'kg',
        birimFiyat: 85,
        toplamFiyat: 4250,
        durum: 'teslim',
        stokMiktar: 0,
        kullanilanMiktar: 50,
        uygulamaYeri: 'A Blok Daireler',
        katSayisi: 1,
        uygulamaMetrekare: 2000,
        insaatId: 'c-001',
        not: 'Astar uygulaması tamamlandı',
        createdAt: '2026-01-12T09:00:00Z',
        updatedAt: '2026-01-15T14:00:00Z',
    },
    {
        id: 'by-003',
        siparisTarihi: '2026-01-14',
        teslimTarihi: '2026-01-15',
        tedarikci: 'Marshall Boya',
        tedarikciFirmaId: 'f-080',
        kategori: 'dis-cephe',
        urunAdi: 'Marshall Dış Cephe',
        aciklama: 'Silikon bazlı dış cephe boyası',
        renk: 'Krem',
        renkKodu: '#F5F5DC',
        miktar: 200,
        birim: 'kg',
        birimFiyat: 180,
        toplamFiyat: 36000,
        durum: 'teslim',
        stokMiktar: 200,
        kullanilanMiktar: 0,
        uygulamaYeri: 'A Blok Dış Cephe',
        katSayisi: 0,
        uygulamaMetrekare: 0,
        insaatId: 'c-001',
        not: 'Mantolama sonrası uygulanacak',
        createdAt: '2026-01-14T10:00:00Z',
        updatedAt: '2026-01-15T11:00:00Z',
    },
    {
        id: 'by-004',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Dyo Boya',
        tedarikciFirmaId: 'f-082',
        kategori: 'tavan',
        urunAdi: 'Dyo Tavan Boyası',
        aciklama: 'Tavan özel mat boya',
        renk: 'Beyaz',
        renkKodu: '#FFFFFF',
        miktar: 80,
        birim: 'kg',
        birimFiyat: 95,
        toplamFiyat: 7600,
        durum: 'teslim',
        stokMiktar: 20,
        kullanilanMiktar: 60,
        uygulamaYeri: 'A Blok Daireler',
        katSayisi: 2,
        uygulamaMetrekare: 800,
        insaatId: 'c-001',
        not: 'Daire tavanları',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-16T15:00:00Z',
    },
];

// Boya kategorileri
export const boyaKategorileri = [
    { key: 'ic-cephe', label: 'İç Cephe', icon: '🏠' },
    { key: 'dis-cephe', label: 'Dış Cephe', icon: '🏢' },
    { key: 'tavan', label: 'Tavan', icon: '⬆️' },
    { key: 'astar', label: 'Astar', icon: '🎨' },
    { key: 'vernik', label: 'Vernik', icon: '✨' },
];

// İstatistikler
export const getBoyaStats = (insaatId) => {
    const filtered = insaatId
        ? boyaMalzemeler.filter(s => s.insaatId === insaatId)
        : boyaMalzemeler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);
    const toplamMetrekare = filtered.reduce((acc, s) => acc + s.uygulamaMetrekare, 0);
    const stokKg = filtered.reduce((acc, s) => acc + s.stokMiktar, 0);

    return { toplamKalem, teslimEdilen, toplamMaliyet, toplamMetrekare, stokKg };
};

// Helper: insaata göre filtrele
export const getBoyaByInsaat = (insaatId) => {
    if (!insaatId) return boyaMalzemeler;
    return boyaMalzemeler.filter(s => s.insaatId === insaatId);
};
